import React from "react";

export function Taboola() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="#1B2430"
      />
      <path
        d="M8.25 7.5H15.75V9.25H13.125V16.5H10.875V9.25H8.25V7.5Z"
        fill="#FAFAFA"
      />
      <path
        d="M17.2 14.25C17.2 15.9595 15.8095 17.35 14.1 17.35C12.3905 17.35 11 15.9595 11 14.25C11 12.5405 12.3905 11.15 14.1 11.15C15.8095 11.15 17.2 12.5405 17.2 14.25Z"
        fill="#00B67A"
        opacity="0.9"
      />
    </svg>
  );
}

